import React, { useState } from "react";
import ReactDatePicker from "react-datepicker";
import { BlueCalendar } from "./Icon";

const App = () => {
  const [startDate, setStartDate] = useState(new Date("08/02/2014"));
  const [endDate, setEndDate] = useState(new Date("10/02/2014"));
  return (
    <>
      <div className="flex items-center justify-between border date_picker border-primary rounded-[37px] py-3 px-2 md:px-[14px] w-[202px] md:w-[202px]">
        <BlueCalendar/>
      <div className="flex items-center">
          <ReactDatePicker className="date_modified"
        selected={startDate}
        onChange={(date) => setStartDate(date)}
        selectsStart
        startDate={startDate}
        endDate={endDate}
      />
      <p className="px-1 text-xs text-primary font-normal pt-[2px]">To</p>
      <ReactDatePicker
        selected={endDate}
        onChange={(date) => setEndDate(date)}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
      />
      </div>
      </div>
    </>
  );
};
export default App;
